import { ApartmentEntry, ApartmentStatus } from '../../types/config';

export const inventoryDataShbiroNeveZemer: ApartmentEntry[] = [
  {
    building: 'A',
    number: 7,
    type: 'A7',
    floor: 3,
    rooms: 4,
    area: 96.0,
    balconyArea: 13.0,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_A7_select_floor3',
    nrId: 1,
    galleryType: 'galleryA7',
    galleryCount: 12,
    tourUrl: 'https://my.treedis.com/tour/a7-f5a93a8e',
    hasVideo: true,
    floorPlanImage: 'floorplanA7',
    mainImage: 'main_image',
  },
  {
    building: 'A',
    number: 12,
    type: 'A12',
    floor: 4,
    rooms: 5,
    area: 128.0,
    balconyArea: 13.0,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'A_A12_select_floor4',
    nrId: 2,
    galleryType: 'galleryA12',
    galleryCount: 14,
    tourUrl: 'https://my.treedis.com/tour/a12-f56f6',
    hasVideo: true,
    floorPlanImage: 'floorplanA12',
    mainImage: 'main_image',
  },
  {
    building: 'B',
    number: 15,
    type: 'B15',
    floor: 5,
    rooms: 6,
    area: 180.0,
    balconyArea: 120.0,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'B_B15_select_floor5',
    nrId: 3,
    galleryType: 'galleryB15',
    galleryCount: 18,
    tourUrl: 'https://my.treedis.com/tour/b-15-43e91902',
    hasVideo: true,
    floorPlanImage: 'floorplanB15',
    mainImage: 'main_image',
  },
];
